<div class="border-card border-0 px-3 py-1 scroll-container" ref="manage_workflow">
  <NavigationBackButton />

  <!-- Top Info Card -->
  <div class="card-header bg-white card-nav-tabs border-0 shadow mt-2 rounded-top-lg ms-2 mb-2">
    <div class="d-flex">
      <div class="d-flex align-items-center">
          <i class="bx bx-user fs-4 text-dark me-2"></i>
          <div class="d-flex flex-column justify-content-center">
            <p class="fw-bold text-dark mb-0 text-x">{{ lead_name }}</p>
            <span 
              class="text-xs fw-bold" 
              :style="{ color: get_status_color(application_status) }"
              :class="{ 'text-muted': !is_status_colors_loaded }"
            >
              {{ application_status }}
              <small v-if="!is_status_colors_loaded" class="text-xxs">(loading colors...)</small>
            </span>
          </div>
        </div>
    </div>
  </div>

  <!-- Main Application Layout -->
  <div class="overview-application-container">
    <div class="overview-vertical-tabs-container overview-scrollable-container">
      <div 
      class="overview-floating-tab shadow rounded-lg"
      :class="{ 'active': activeTab === 'enquiry' }"
      @click="selectTab('enquiry')"
    >
      <div class="overview-floating-tab-inner text-dark-blue text-xs">
        <span>Enquiry</span>
      </div>
    </div>
      <div 
        class="overview-floating-tab shadow rounded-lg"
        :class="{ 'active': activeTab === 'questionnaires' }"
        @click="selectTab('questionnaires')"
      >
        <div class="overview-floating-tab-inner text-dark-blue text-xs">
          <span>Questionnaires</span>
        </div>
      </div>
      <div 
      class="overview-floating-tab shadow rounded-lg"
      :class="{ 'active': activeTab === 'minutes' }"
      @click="selectTab('minutes')"
    >
      <div class="overview-floating-tab-inner text-dark-blue text-xs">
        <span>Minutes</span>
      </div>
    </div>
      <div 
        class="overview-floating-tab shadow rounded-lg"
        :class="{ 'active': activeTab === 'quotation' }"
        @click="selectTab('quotation')"
      >
        <div class="overview-floating-tab-inner text-dark-blue text-xs">
          <span>Quotation</span>
        </div>
      </div>
      <div 
        class="overview-floating-tab shadow rounded-lg"
        :class="{ 'active': activeTab === 'invoice' }"
        @click="selectTab('invoice')"
      >
        <div class="overview-floating-tab-inner text-dark-blue text-xs">
          <span>Invoices</span>
        </div>
      </div>
      <div
        class="overview-floating-tab shadow rounded-lg"
        :class="{ 'active': activeTab === 'proof of payment' }"
        @click="selectTab('proof of payment')"
      >
        <div class="overview-floating-tab-inner text-dark-blue text-xs">
          <span>Proof of Payments</span>
        </div>
      </div>
    </div>

    <!-- Dropdown Section Content Area -->
    <div class="ms-2 overview-dropdown-column rounded-lg shadow-lg">
      <div class="overview-accordion-container mb-3 border-0 rounded-lg" id="stages_accordion">
          <!-- Enquiry Tab Content -->
          <div class="accordion-item bg-secondary-dark" v-if="activeTab === 'enquiry'">
            <h2 class="accordion-header primary-green  border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-dark-blue">Enquiry</span>
                </div>
                <a class="fw-bold fs-6 p-0 ms-2 text-dark" @click.stop="toggleDropdown('enquiry')" type="button">
                  <i class="bi" :class="{'text-white bi-chevron-down': selectedDropdown !== 'enquiry', 'text-white bi-chevron-up': selectedDropdown === 'enquiry'}"></i>
                </a>
              </div>
            </h2>
            <div class="collapse" :class="{ 'show': selectedDropdown === 'enquiry' }">
                <EnquiryChat />
            </div>
          </div>

          <!-- questionnaires Tab Content -->
          <div class="accordion-item bg-secondary-dark" v-if="activeTab === 'questionnaires'">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-dark-blue">Questionnaires</span>
                </div>
                <a class="fw-bold fs-6 p-0 ms-2 text-dark" @click.stop="toggleDropdown('questionnaires')" type="button">
                  <i class="bi" :class="{'text-white bi-chevron-down': selectedDropdown !== 'questionnaires', 'text-white bi-chevron-up': selectedDropdown === 'questionnaires'}"></i>
                </a>
              </div>
            </h2>
            <div class="collapse" :class="{ 'show': selectedDropdown === 'questionnaires' }">
                <LeadQuestionnaire />
              </div>
          </div>

          <!-- Minutes Tab Content -->
          <div class="accordion-item bg-secondary-dark" v-if="activeTab === 'minutes'">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-dark-blue">Minutes</span>
                </div>
                <a class="fw-bold fs-6 p-0 ms-2 text-dark" @click.stop="toggleDropdown('minutes')" type="button">
                  <i class="bi" :class="{'text-white bi-chevron-down': selectedDropdown !== 'minutes', 'text-white bi-chevron-up': selectedDropdown === 'minutes'}"></i>
                </a>
              </div>
            </h2>
            <div class="collapse" :class="{ 'show': selectedDropdown === 'minutes' }">
                  <UploadMeetingMinutes :lead_id="lead_id" />
            </div>
          </div>

          <div class="accordion-item bg-secondary-dark" v-if="activeTab === 'quotation'">
              <EntityReviewQuote />
          </div>

          <div class="accordion-item bg-secondary-dark" v-if="activeTab === 'invoice'">
              <h2 class="accordion-header primary-green  border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-dark-blue">Invoice</span>
                </div>
                <a class="fw-bold fs-6 p-0 ms-2 text-dark" @click.stop="toggleDropdown('invoice')" type="button">
                  <i class="bi" :class="{'text-white bi-chevron-down': selectedDropdown !== 'invoice', 'text-white bi-chevron-up': selectedDropdown === 'invoice'}"></i>
                </a>
              </div>
            </h2>
            <div class="collapse px-2" :class="{ 'show': selectedDropdown === 'invoice' }">
                <EntityInvoiceOverview />
              </div>
            <!-- </div> -->
          </div>

          <div class="accordion-item bg-secondary-dark" v-if="activeTab === 'proof of payment'">
            <h2 class="accordion-header primary-green  border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-dark-blue">Proof of Payment</span>
                </div>
                <a class="fw-bold fs-6 p-0 ms-2 text-dark" @click.stop="toggleDropdown('proof of payment')" type="button">
                  <i class="bi" :class="{'text-white bi-chevron-down': selectedDropdown !== 'proof of payment', 'text-white bi-chevron-up': selectedDropdown === 'proof of payment'}"></i>
                </a>
              </div>
            </h2>
            <div class="collapse" :class="{ 'show': selectedDropdown === 'proof of payment' }">
                <ProofOfPayments />
            </div>
        </div>
      </div>
    </div>
  </div>
</div>